import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizednumber',
  pure: false
})
export class LocalizedDecimalPipe implements PipeTransform {
  constructor(protected translate: TranslateService) { }

  transform(value: any, digitsInfo: string = '1.0-0'): any {
    let locale = this.translate.currentLang;
    if (locale.startsWith('sv') || locale.startsWith('se'))
      locale = 'se-SE';
    else if (locale.startsWith('ar'))
      locale = 'ar-SY';
    else if (locale.startsWith('en'))
      locale = 'en-GB';
    else if (locale.startsWith('pl'))
      locale = 'pl-PL';
    else if (locale.startsWith('de'))
      locale = 'de-DE';
    const decimalPipe: DecimalPipe = new DecimalPipe(locale);
    return decimalPipe.transform(value, digitsInfo);
  }
}
